import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgArrowLeftIconSecondary from './svgs/ArrowLeftIconSecondary.js';
import SvgArrowLeftIcon from './svgs/ArrowLeftIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var ArrowLeftIcon = (props => useIcon(SvgArrowLeftIcon, SvgArrowLeftIconSecondary, props));

export { ArrowLeftIcon as default };
